module.exports = __webpack_public_path__ + "img/the-netherlands-respiratory-diseases-female.810eed4c.png";